import {Button} from "react-bootstrap";
import {useContext} from "react";
import AuthContext from "../../store/auth-context";
import {useNavigate} from "react-router-dom";

const Logout:React.FC = () => {
    const authCtx = useContext(AuthContext);
    let navigate = useNavigate();

    const handleLogout = () => {
        authCtx.logout();
        navigate("/");
    }

    return <Button className="mx-1" variant="secondary" onClick={handleLogout} >Logout</Button>;
}

export default Logout;